import { NativeModules, Platform } from 'react-native'

// Vendored from @statsig/react-native-core's StatsigMetadataAdditions, with the
// `react-native-device-info` dependency intentionally REMOVED — that package is
// a native module (not in Expo Go, needs a dev build) and we don't want to
// require it. The app-version / device-model fields it provided are simply left
// `undefined`; we still surface `systemName` (free via `Platform.OS`) and the
// `locale` (read from RN's built-in NativeModules, no extra dependency).

type I18nManagerModule = { localeIdentifier?: string }
type SettingsManagerModule = {
  settings?: { AppLocale?: string; AppleLanguages?: string[] }
}

function resolveLocale(): string | undefined {
  if (Platform.OS === 'android') {
    const i18nManager = NativeModules.I18nManager as
      | I18nManagerModule
      | undefined
    return i18nManager?.localeIdentifier ?? undefined
  }

  if (Platform.OS === 'ios') {
    const settings = (
      NativeModules.SettingsManager as SettingsManagerModule | undefined
    )?.settings
    return settings?.AppLocale ?? settings?.AppleLanguages?.[0] ?? undefined
  }

  return undefined
}

export function getStatsigMetadataAdditions(): Record<
  string,
  string | undefined
> {
  return {
    // Device-info-derived fields are dropped (no react-native-device-info).
    appVersion: undefined,
    systemVersion: undefined,
    deviceModelName: undefined,
    deviceModel: undefined,
    // Available without any native module:
    systemName: Platform.OS,
    locale: resolveLocale(),
  }
}
